import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment.prod';
import { Notification } from '../../../../core/Notifications/Notification';

@Component({
  selector: 'app-otpbox',
  templateUrl: './otpbox.component.html',
  styleUrls: ['./otpbox.component.scss']
})
export class OtpboxComponent implements OnInit {
  OTP: any;
  Id: any;
  Message: string = "";
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any, private Http: HttpClient, private notify: Notification, private router: Router, public dialogRef: MatDialogRef<OtpboxComponent>) { }

  ngOnInit(): void {
    this.Sendotp()
  }
  Sendotp() {
    console.log('Data', this._data.PR_MobileNumber);
    let Data = {
      Id: 0,
      Phonenumber: this._data.PR_MobileNumber,
      Email: "",
    }
    this.Http.post(`${environment.Login_URL}` + `api/Authentication/SendOTP`, Data).subscribe((data: any) => {
      console.log('Data', data);
      this.Id = data.Id;

    })
  }
  OTPVerfiy() {
    this.Http.get(`${environment.Login_URL}` + `api/Authentication/OTPVerfiy/` + this.Id + `/` + this.OTP).subscribe(data => {
      console.log('Data', data);
      if (data) {

        this.Message = "OTP Successfuly verfied";
        this.dialogRef.close(1);
        this.onSubmit();
        this.router.navigate(["/auth/login"]);
      }
      else
        this.Message = "Invalid OTP";
    })
  }
  onSubmit() {
    // const header = new HttpHeaders({ 'Content-Type': '' });
    //.append('scope', 'Global_api');
    console.log('Data', this._data);
    this.Http.post(`${environment.Login_URL}` + `api/Authentication/PatientRegister`, this._data).subscribe(data => {
      this.notify.successmsg("Guest" + " logged Successfully.");
    })
  }

}
